(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/areas/play/play.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/areas/play/play.js');
'use strict';

const GameLauncherWrapper = svs.tickets.next.areas.play.containers.GameLauncherWrapper;
const AnimatedBackgrounds = svs.tickets.next.components.animatedBackground.AnimatedBackgrounds;
const NavigationBack = svs.tur.NavigationBack;
const getPositiveIntegerParam = key => {
  const value = svs.utils.paramHandler.get({
    key
  }).value;
  const parsedValue = parseInt(value, 10);
  return Number.isFinite(parsedValue) && parsedValue > 0 ? parsedValue : null;
};
const Play = _ref => {
  var _svs$tickets$data$mod;
  let history = _ref.history,
    location = _ref.location,
    match = _ref.match;
  const _ref2 = (match === null || match === void 0 ? void 0 : match.params) || {},
    ticketType = _ref2.ticketType,
    wagerId = _ref2.wagerId;
  const isDemo = wagerId === 'demo';
  const availableTickets = ((_svs$tickets$data$mod = svs.tickets.data.moduleConfig) === null || _svs$tickets$data$mod === void 0 ? void 0 : _svs$tickets$data$mod.availableTickets) || [];
  const ticketInfo = availableTickets.find(ticket => {
    var _ticket$alternativeUr;
    return ticket.type.toLowerCase() === (ticketType === null || ticketType === void 0 ? void 0 : ticketType.toLowerCase()) || ((_ticket$alternativeUr = ticket.alternativeUrl) === null || _ticket$alternativeUr === void 0 ? void 0 : _ticket$alternativeUr.toLowerCase()) === (ticketType === null || ticketType === void 0 ? void 0 : ticketType.toLowerCase());
  });
  const ticketTitle = (ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.name) || (ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.type);
  const ticketNumber = getPositiveIntegerParam('ticketNumber');
  const skinIdFromTicketNumber = ticketNumber && ticketInfo ? svs.tickets.next.utils.utils.getSelectedTicketVariation(ticketNumber, ticketInfo) : null;
  const skinId = ticketInfo !== null && ticketInfo !== void 0 && ticketInfo.defaultSkin ? 1 : skinIdFromTicketNumber || getPositiveIntegerParam('skinId') || 1;
  const handleBack = () => {
    history.push("/valja/".concat(ticketType));
  };
  const currentPath = (location === null || location === void 0 ? void 0 : location.pathname) || window.location.pathname;
  const routes = {
    [currentPath]: {
      text: "".concat(ticketTitle, " "),
      navigate: () => history.push("/valja/".concat(ticketType))
    }
  };
  if (!ticketInfo) {
    svs.utils.url.navigate(svs.core.urlMapping.get('trissHome'));
    return null;
  }
  return React.createElement("div", {
    className: "w100 h100"
  }, React.createElement(NavigationBack, {
    brand: "next-lobby",
    routes: routes
  }), React.createElement("div", {
    className: "next-play-background-stage"
  }, React.createElement("div", {
    "aria-hidden": "true",
    className: "next-play-animated-background"
  }, React.createElement("div", {
    className: "next-play-animated-background__frame"
  }, React.createElement(AnimatedBackgrounds, {
    animate: false,
    ticketInfo: ticketInfo
  }))), React.createElement("div", {
    className: "next-play-background-stage__content"
  }, React.createElement(GameLauncherWrapper, {
    demo: isDemo,
    history: history,
    onClose: handleBack,
    skinId: skinId,
    ticketInfo: ticketInfo,
    ticketNumber: ticketNumber,
    topBarTrackingLocation: "spela",
    wagerId: wagerId
  }))));
};
setGlobal('svs.tickets.next.areas.play.Play', Play);

 })(window);